import React, { FC, useEffect, useState } from "react";
import { BarLoader } from "react-spinners";
// shared
import { Title } from "shared/ui/title";
import { BaseInput } from "shared/ui/input";
import { Button } from "shared/ui/button";
import SearchIcon from "shared/icons/controls/search.svg";
import icon from "shared/icons/navbar/specialists-active.svg";
// widgets
import { DoctorWidget } from "widgets/doctors/ui";
// features
import { ModuleCreateUsersFeature } from "features/module/module-add-users";
// effector
import { useStore } from "effector-react";
// entities
import { SpecialistModel } from "entities/doctors";

const SpecialistPage: FC = () => {
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const allDoctors = useStore(SpecialistModel.$doctorsUsers);
  const isLoading = useStore(SpecialistModel.getAllDoctorsFx.pending);

  const handleAddButtonClick = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    SpecialistModel.getAllDoctorsFx();
  }, []);

  return (
    <div style={{ height: "calc(100vh - 70px)" }} className={"bg-[#F5F8FE]"}>
      <div className={"w-full px-4 py-4 h-[100%]"}>
        <Title className={"mb-6"} dark>
          Специалисты
        </Title>
        <div
          className={
            "flex justify-between items-center mb-5 bg-[#EAF2FC] p-3 rounded-xl"
          }
        >
          <div className={"w-[38%]"}>
            <BaseInput
              placeholder={"Найти специалиста"}
              renderLeftIcon={SearchIcon}
              onInputChange={setSearchText}
            />
          </div>
          <div className={"flex"}>
            <div className={"w-[201px]"}>
              <Button onClick={handleAddButtonClick}>Добавить</Button>
            </div>
          </div>
        </div>
        {!isLoading ? (
          <DoctorWidget
            page="twoStatus"
            users={allDoctors}
            haveChat={false}
            searchText={searchText}
          />
        ) : (
          <div className="flex items-center justify-center w-full h-[74%]">
            <BarLoader color="#36D7B7" width={500} loading={isLoading} />
          </div>
        )}
        {visible && (
          <div className="overlay">
            <ModuleCreateUsersFeature
              icon={icon}
              title="Новый специалист"
              onChange={handleAddButtonClick}
              visible={visible}
              options={[
                { label: "Активный", value: "ACTIVE" },
                { label: "Приостановлен", value: "INACTIVE" },
              ]}
              role="doctor"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export { SpecialistPage };
